import classNames from 'classnames';
import { tChatEvent } from '../../../../../../Chat.types.ts';
import FunnelMoveBubble from './components/FunnelMoveBubble/FunnelMoveBubble.component.tsx';
import LeadCloseBubble from 'src/components/LeadClose/LeadCloseBubble.component';
import { useUserContext } from 'src/providers/UserProvider/User.context';
import './SystemBubble.styles.scss';

export default function SystemBubble(props: { event: tChatEvent }) {
  const { event } = props;
  const subtype = event.system?.subtype;
  const { currentUser } = useUserContext();

  // LEA-50: a result of the lead, from its close summary.
  if (subtype === 'lead-close' && event.system?.leadClose) {
    const result = event.system.leadClose;
    return (
      <LeadCloseBubble
        result={result}
        mine={
          Boolean(currentUser?.uuid) && result.actor_uuid === currentUser?.uuid
        }
      />
    );
  }

  // Funnel-move gets a richer lilac card (matching the escalation note) with a
  // deep-link to the destination funnel, rather than the generic status pill.
  if (subtype === 'funnel-move') {
    return <FunnelMoveBubble event={event} />;
  }

  return (
    <div className="SystemBubble">
      <div
        className={classNames('SystemBubble__pill', {
          'SystemBubble__pill--stageAdvance': subtype === 'stage-advance',
          'SystemBubble__pill--handoff': subtype === 'handoff',
          'SystemBubble__pill--resume': subtype === 'resume',
        })}
      >
        {event.content?.text}
      </div>
    </div>
  );
}
